module.exports = __webpack_public_path__ + "img/individ-fon.285cd06a.png";